import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from '../Breadcrumb';
import './PsPage.css';

export const PsPage = (
    {
        title,
        children,
        location,
        breadcrumbs,
    },
) => {
    return (
        <div className="ps-page">
            <Breadcrumb location={location} breadcrumbs={breadcrumbs}/>
            <div className="block-header">
                <h2>{title}</h2>
            </div>
            {children}
        </div>
    );
};

PsPage.propTypes = {
    title: PropTypes.string.isRequired,
    location: PropTypes.any,
    breadcrumbs: PropTypes.array.isRequired,
};

PsPage.defaultProps = {
    title: '',
    location: null,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/ps-page/PsPage.jsx